module.exports = __webpack_public_path__ + "img/400e.45dc94d1.png";